import { z } from 'zod';

/** Канарейка фронта: минимально нужное, ничего лишнего о госте. */
export const ClientErrorReport = z.object({
  app: z.enum(['pos', 'kds', 'backoffice', 'menu', 'admin', 'waiter', 'courier', 'count']),
  message: z.string().max(500),
  stack: z.string().max(4000).optional(),
  url: z.string().max(300),
  build: z.string().max(40),
  /** какой раздел был открыт: стек минифицирован, а это читается сразу */
  screen: z.string().max(40).optional(),
});
export type ClientErrorReport = z.infer<typeof ClientErrorReport>;
